/**
 * Color helpers that work with BOTH a literal hex (React Native) and a
 * `var(--tc-…)` token (web).
 *
 * Appending a hex alpha suffix (`${color}80`) only works on a literal hex; once
 * a token is a CSS variable, that produces `var(...)80`, which is invalid and
 * silently drops the color. Use withAlpha instead — it parses a hex to rgba on
 * native and uses color-mix on web, where the variable re-resolves when the
 * theme flips.
 */

/** A translucent version of a color. `alpha` is a fraction, 0–1. */
export function withAlpha(color: string, alpha: number): string {
  const a = Math.max(0, Math.min(1, alpha));
  if (color.startsWith('#') && (color.length === 7 || color.length === 4)) {
    const hex = color.length === 4 ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}` : color;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  return `color-mix(in srgb, ${color} ${Math.round(a * 100)}%, transparent)`;
}
